import classnames from 'classnames';
import React, { useRef } from 'react';
import { Checkbox } from "../../../checkbox/Checkbox.js";
import styles from "./MultiSelectOptions.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const MultiSelectOption = ({
  active,
  disabled,
  label,
  'data-index': dataIndex,
  onChange,
  value,
  mobile = false,
  ...liProps
}) => {
  const liRef = useRef(null);
  const classes = classnames(styles.multiSelectOption, {
    [styles.disabled]: disabled,
    [styles.mobile]: mobile
  });
  return /*#__PURE__*/_jsx("li", {
    ...liProps,
    className: classes,
    "data-index": dataIndex,
    ref: liRef,
    children: /*#__PURE__*/_jsx(Checkbox, {
      checked: active,
      classNames: classnames(styles.checkbox, active && styles.active),
      title: label,
      onChange: e => onChange?.(e.target.checked),
      children: label
    })
  }, value);
};